import React from 'react'
import { PropertySearch } from '../../../../containers'
import { Grid, Column, Button } from '../../..'
import styles from './PropertyForm.module.scss'

interface ISearchPropertiesProps {
  isReadonly: boolean
  isDraftPortfolio: boolean
  redirect: (url: string) => void
  portfolioId: string
}

const SearchProperties = ({
  isReadonly,
  isDraftPortfolio,
  redirect,
  portfolioId,
}: ISearchPropertiesProps): React.ReactNode => {
  return (
    <div className={styles.root}>
      <div className={styles.form}>
        <div className={styles.body}>
          <Grid>
            <Column xs={12} md={8} flexOptions="padding-r-1">
              <PropertySearch isReadonly={isReadonly} />
            </Column>
          </Grid>
          <div className={styles['preview-footer']}>
            {isDraftPortfolio && <Button onClick={() => redirect(`/leases/${portfolioId}/edit/type`)}>Back</Button>}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SearchProperties
